// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"24":"companies","106":"user-management","792":"main","884":"admin"}[chunkId] || chunkId) + "." + {"24":"29a94178","37":"1c34f194","106":"1f603d61","792":"f44e726f","884":"0a6761a5"}[chunkId] + ".js";
};